// app/javascript/controllers/stripe_features_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "template"]

  addFeature(event) {
    event.preventDefault();
    // Create a unique identifier for new entries
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.listTarget.insertAdjacentHTML('beforeend', content);
  }

  removeFeature(event) {
    event.preventDefault();
    if (confirm('Are you sure?')) {
      event.target.closest('.feature-item').remove();
    }
  }
}
